module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Φορτώνει...","flags":["TRACK"],"track":"Loading..."}}